import { useQuery } from '@tanstack/react-query';

import { QUERY_STALE_TIMES } from '../../shared/providers/react-query-provider';
import { DossierId } from '../dossier/types';

import { getPhoneCalls } from './api';
import { PhoneCall } from './types';

export const getPhoneCallsQueryKey = (dossierId: DossierId) => ['phoneCalls', dossierId];

export const useGetPhoneCalls = (dossierId: DossierId) => {
    return useQuery<PhoneCall[]>({
        queryKey: getPhoneCallsQueryKey(dossierId),
        queryFn: () => getPhoneCalls(dossierId),
        enabled: !!dossierId,
        staleTime: QUERY_STALE_TIMES.DISCUSSION,
    });
};
